import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const CardFooterAction = ({
  actionConfig,
  toObjectTypeId,
  usageTracker
}) => {
  const {
    disabled,
    external,
    href,
    label,
    onClick,
    disabledTooltipText
  } = actionConfig;
  const handleClickWithTracking = useCallback(() => {
    usageTracker === null || usageTracker === void 0 || usageTracker.track('sidebar-interaction', {
      type: toObjectTypeId,
      action: 'Association card primary action'
    });
    onClick === null || onClick === void 0 || onClick();
  }, [onClick, toObjectTypeId, usageTracker]);
  const buttonElement = /*#__PURE__*/_jsx(Button, {
    "data-test-id": 'card-footer-primary-action',
    disabled: disabled,
    external: external,
    href: href,
    onClick: handleClickWithTracking,
    size: 'xs',
    use: 'secondary',
    children: label
  });
  if (disabledTooltipText) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: disabledTooltipText,
      children: buttonElement
    });
  }
  return buttonElement;
};
export default CardFooterAction;